var map = {
	"./Alpina_Gstaad.jpg": [
		147,
		0
	],
	"./Backstage_Zermatt.jpg": [
		148,
		1
	],
	"./Badrutt_St_Moritz.jpg": [
		149,
		12
	],
	"./Belvedere_Scuol.jpg": [
		150,
		23
	],
	"./Bergwelt_Grindelwald.jpg": [
		151,
		30
	],
	"./Chedi_Andermatt.jpg": [
		152,
		31
	],
	"./Chesa_Randolina_Sils.jpg": [
		153,
		32
	],
	"./Doldenhorn_Kandersteg.jpg": [
		154,
		33
	],
	"./Grand_Bellevue_Gstaad.jpg": [
		155,
		34
	],
	"./Guardaval_Lenzerheide.jpg": [
		156,
		35
	],
	"./Hornberg_Gstaad.jpg": [
		157,
		2
	],
	"./Inlain_Brail.jpg": [
		158,
		3
	],
	"./Kempinski_Engelberg.jpg": [
		159,
		4
	],
	"./Kernen_Schoenried_Gstaad.jpg": [
		160,
		5
	],
	"./Krone_La_Punt.jpg": [
		161,
		6
	],
	"./Kulm_St_Moritz.jpg": [
		162,
		7
	],
	"./Margna_Sils.jpg": [
		163,
		8
	],
	"./Meisser_Guarda.jpg": [
		164,
		9
	],
	"./Palace_Gstaad.jpg": [
		165,
		10
	],
	"./Priva_Lenzerheide.jpg": [
		166,
		11
	],
	"./Radisson_Andermatt.jpg": [
		167,
		13
	],
	"./Riffelalp_Zermatt.jpg": [
		168,
		14
	],
	"./Rockresort_Laax.jpg": [
		169,
		15
	],
	"./Schoenegg_Wengen.jpg": [
		170,
		16
	],
	"./Schweizerhof_Lenzerheide.jpg": [
		171,
		17
	],
	"./Schweizerhof_Zermatt.jpg": [
		172,
		18
	],
	"./Spitzhorn_Saanen.jpg": [
		173,
		19
	],
	"./Sporthotel_Pontresina.jpg": [
		174,
		20
	],
	"./Steinbock_Pontresina.jpg": [
		175,
		21
	],
	"./Suvretta_St_Moritz.jpg": [
		176,
		22
	],
	"./Tschuggen_Arosa.jpg": [
		177,
		24
	],
	"./Waldhaus_st_Moritz.jpg": [
		178,
		25
	],
	"./Walther_Pontresina.jpg": [
		179,
		26
	],
	"./Zermatterhof_Zermatt.jpg": [
		180,
		27
	],
	"./Zurbriggen_Saas.jpg": [
		181,
		28
	],
	"./jungfrau-wengernalp.jpg": [
		182,
		29
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 72;
module.exports = webpackAsyncContext;